<div class="main-layout">
  <app-header></app-header>
  <main class="main-content">
    @if(!hideSideBar()) {
      <app-side-nav></app-side-nav>
    }
    <div class="content tds-u-flex tds-u-flex-dir-col tds-background-white">
      @if(!hideBreadcrumbs()) {
        <!-- <nav-breadcrumbs></nav-breadcrumbs> -->
      }
      <app-toast></app-toast>
      <!-- <app-notify-toast></app-notify-toast> -->
      <app-spinner></app-spinner>
      <app-countdown-popup></app-countdown-popup>
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div> 